import { render, staticRenderFns } from "./lowPriceRealtimeDetail.vue?vue&type=template&id=bdef3448&scoped=true"
import script from "./lowPriceRealtimeDetail.vue?vue&type=script&lang=js"
export * from "./lowPriceRealtimeDetail.vue?vue&type=script&lang=js"
import style0 from "./lowPriceRealtimeDetail.vue?vue&type=style&index=0&id=bdef3448&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdef3448",
  null
  
)

export default component.exports